export class VoiceMailModel {
    callSid: string;
    voiceGreetingId: string;
    constructor(init?: Partial<VoiceMailModel>) {
        Object.assign(this, init);
    }
}
